import React, {forwardRef, useImperativeHandle} from 'react';
import makeStyles from '@mui/styles/makeStyles';

import CanvasDraw from "./canvasDraw/index";
import {TextareaAutosize, TextField} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    addTextInput: {
        "& #textInput": {
            color: "black",
            paddingTop: 2,
            paddingLeft: 5,
            paddingBottom: 2,
            paddingRight: 5,
        }
    }
}));

function EditorImageComponent(props, ref) {
    const classes = useStyles();
    useImperativeHandle(ref, () => ({
        getData: () => {
            return canvasRef.current.getDataURL("png");
        },
        clear: () => {
            canvasRef.current.clear();
            setShowInput(false);
        }
    }));

    const [showInput, setShowInput] = React.useState(false);
    const [inputPosTop, setInputPosTop] = React.useState(0);
    const [inputPosLeft, setInputPosLeft] = React.useState(0);
    const canvasRef = React.useRef(null);

    const setShowInputHandler = (val, ev) => {
        if(ev && ev.clientX && ev.clientY){
            let canvasElName = (props.canvasId ? props.canvasId : "imageEditor") + "-interface";
            let rect = document.getElementById(canvasElName).getBoundingClientRect();
            let valueTop = ev.clientY - rect.top - 6;
            if(valueTop < 0){
                valueTop = 0;
            }
            if(valueTop > (rect.bottom - 16)){
                valueTop = rect.bottom + 16;
            }
            setInputPosTop(valueTop);
            let valueLeft = ev.clientX - rect.left;
            if((valueLeft + 260) > rect.right){
                valueLeft = rect.right - 260;
            }
            setInputPosLeft(valueLeft);
        }
        setShowInput(val);
    }

    const onInputBlur = () => {
        document.getElementById("textInput").value = "";
        setShowInput(false);
    }

    const inputWidth = 200;
    const maxTextInputLength = 200;
    const maxInputTextRows = 3;
    const fontSize = 16;
    const lineHeight = 20;

    const printOnCanvas = (canvasCtx, text, x, y, lineHeight, fitWidth) => {
        fitWidth = fitWidth || 0;
        if (fitWidth <= 0)
        {
            canvasCtx.fillText( text, x, y );
            return;
        }
        for (var idx = 1; idx <= text.length; idx++)
        {
            var str = text.substr(0, idx);
            if (canvasCtx.measureText(str).width > fitWidth || str.charCodeAt(idx-1) == 10)
            {
                canvasCtx.fillText( text.substr(0, idx), x, y );
                printOnCanvas(canvasCtx, text.substr(idx), x, y + lineHeight, lineHeight,  fitWidth);
                return;
            }
        }
        canvasCtx.fillText( text, x, y );
    }

    //const : max TextLength
    //const : max rows ( exactly this determinate how many times goes fill text function
    //check measure text and remind last space sign ( if no space just cat after width max out )
    //recursion ??

    const onInputHandler = (e) => {
        if(!e.shiftKey && (e.key === 'Enter' || e.keyCode == 13)) {
            const ctx = canvasRef.current.canvas.drawing.getContext('2d');
            ctx.font = "" + fontSize + 'px serif';
            printOnCanvas(ctx, e.target.value, inputPosLeft+6, inputPosTop+12, lineHeight, inputWidth);
            //ctx.fillText(e.target.value, inputPosLeft+6, inputPosTop+12)
            onInputBlur();
            e.preventDefault();
        }
        if(e.key === 'Escape' | e.keyCode == 27) {
            onInputBlur();
            e.preventDefault();
        }
    }

    return (
        <div style={{
            // width: 800,
            // height: "60vh",
            // overflow: "hidden",
            position: "relative",
        }}>
            <CanvasDraw
                canvasId={props.canvasId ? props.canvasId : "imageEditor"}
                ref={canvasRef}
                brushRadius={2}
                lazyRadius={props.editMode == "text" ? 0 : 4 }
                catenaryColor={props.currentBrushColor}
                brushColor={props.currentBrushColor}
                canvasWidth={props.imageBackground?.width}
                canvasHeight={props.imageBackground?.height}
                imgSrc={`/image/bm/${props.imageBackground?.name}.png`}
                drawCursor={props.editMode == "text" ? { cursor: "text" } : { cursor: "none" }}
                styles={{}}
                drawMode={props.editMode == "text" ? "text" : "draw"}
                showInputSignal={setShowInputHandler}
                />
            {showInput && <div
                style={{
                    position:"absolute",
                    top:inputPosTop,
                    left:inputPosLeft
                }}>
                <TextareaAutosize
                    className={classes.addTextInput}
                    onBlur={onInputBlur}
                    id="textInput"
                    variant="outlined"
                    onKeyPress={onInputHandler}
                    maxRows={maxInputTextRows}
                    maxLength={maxTextInputLength}
                    style={{ width: inputWidth }}
                    ref={taRef => taRef && taRef.focus()}
                    />

            </div>}
        </div>
    );
}
EditorImageComponent = forwardRef(EditorImageComponent);

export default EditorImageComponent;
